<tt-editor class="col-xs-12 sp-0" ttLabel="add_new_comment" ttLabelView="top" [(ttModel)]="comment" [(ttProcessing)]="editorProcessing"></tt-editor>
<tt-button-save class="col-xs-12 col-md-3 pull-right sp-0" ttText="save" (ttClick)="addNewComment()" [ttDisabled]="editorProcessing" [ttLoading]="saving"></tt-button-save>
<tt-button class="col-xs-12 col-md-3 sp-0" ttText="refresh" ttIcon="far fa-sync-alt" ttType="secondary" (ttClick)="loadComments()" [ttLoading]="loadingComments"></tt-button>
<hr class="k-hr" />
<div class="col-xs-12 sp-5 tt-dialog__comments">
    <tt-comment
        *ngFor="let comment of comments; trackBy: trackItems"
        [ttAuthor]="comment.registered_by_name"
        [ttDatetime]="comment.reg_datetime"
        [ttComment]="comment.messagetext"
        [ttIsCurrentUser]="comment.mymessage"
    >
        <tt-overflow-menu *ngIf="!!ttOptions?.fetch?.delete && comment.mymessage === '1' && !!ttOptions?.keynames?.commentKeyno">
            <tt-overflow-menu-item ttText="delete" ttIcon="far fa-backspace" ttDanger="true" (ttClick)="deleteComment(comment[ttOptions!.keynames!.commentKeyno])"></tt-overflow-menu-item>
        </tt-overflow-menu>
    </tt-comment>
</div>

<style>
    .tt-dialog__comments {
        display: flex;
        flex-direction: column;
        gap: 1.6rem;
        justify-content: flex-start;
    }
</style>
